// extracted by mini-css-extract-plugin
module.exports = {"info":"Info_info__24ZDs","infoTitle":"Info_infoTitle__3n08L","infoContent":"Info_infoContent__2IZpf"};